import React from "react";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import { useWindDirectionColorBar } from "../CustomHooks";

const VirtualWindColorBar = () => {
  const { minValue, maxValue, isVisible } = useWindDirectionColorBar();
  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.OTHER}
      category="Wind Sensors"
      subcategory={"0"}
      unit="m/s"
      dataMin={minValue}
      dataMax={maxValue}
      isVisible={isVisible}
    />
  );
};

export default VirtualWindColorBar;
